import { render, staticRenderFns } from "./BurningMatter.vue?vue&type=template&id=1ac67e61&"
import script from "./BurningMatter.vue?vue&type=script&lang=js&"
export * from "./BurningMatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports